<ng-event-history-dialog
  *ngIf="(store$ | async) as store"
  [configs]="configs"
  [events]="store.events"
  [requestNumber]="data.requestNumber"
  [carId]="data.carId"
  [loading]="store.loading"
></ng-event-history-dialog>
